import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { AssignmentConfigApiResponse } from '@/pages/OperationsInsights/types/AssignmentConfigurationResponse';

export const fetchAssignmentConfigurations = async (): Promise<AssignmentConfigApiResponse> => {
    // This is to covert the beginning of the day in user time.
    const fetchUrl = '/workactivity/back-office/assignment/configurations';
    const resp = await fetchFromLambda(fetchUrl);
    return resp as AssignmentConfigApiResponse;
};
